export enum MessageBoxType {
  Ok = 1,
  YesNo = 2,
  YesNoCancel = 3,
  None = 4,
  NoYes = 5
}
